import { Container, Button,Form, Alert, Modal, Table} from 'react-bootstrap';
import {Sida,Rubrik,ContentWrapper,Stycke,StyckeCompact} from "../ContentStyles";
import { FaFilePdf, FaBars, FaPen } from 'react-icons/fa';
import React, {useMemo, useState, useEffect } from 'react';
import {useParams, useNavigate, useSearchParams, redirect} from 'react-router-dom';
import MaterialReactTable from 'material-react-table';
import useBackend, {CallAPI, Loading, SpinnerX, Check} from '../../services/useBackend_v2';

import {Branding} from '../../services/misc';

import {DateTimeToLocal, MultiselectGetOptions, MultiselectGetDefaultValues, escapedNewLineToLineBreakTag, ConcatLocalDateAndTime2ISO, SplitoutLocalDateFromISO, SplitoutLocalTimeFromISO, getOptions} from '../../services/misc';

export default function Instances() {    
    const { loading, data, Refresh, resultSuccess, resultVariant, resultVisible, resultText, Update, XCall } = useBackend('/api/admin/instances');
    const [instanceDetailsData, setInstanceDetailsData] = useState(null);  

    const impersonate = async (event)  =>  {        
        const { errorsException } = await XCall("/api/admin/impersonate", "PUT", 2000, { InstanceGuid : instanceDetailsData.Guid }, true);
        console.log(instanceDetailsData.Guid);
        if (instanceDetailsData.Guid == '2956a965-46cb-4537-a273-8bb3042c422e') {
            localStorage.setItem('instanceDetailsData', "");
        } else {
            localStorage.setItem('instanceDetailsData', instanceDetailsData.Company);
        }
        setTimeout(function () { window.location.href = "/"; }, 1400);
    }

    const showInstanceDetailsHandler = (event, rowData)  =>  {        
        setInstanceDetailsData(rowData.original)
        setInstanceDetailsModalshow(!instanceDetailsModalshow); 
    }

    const [instanceDetailsModalshow, setInstanceDetailsModalshow] = useState(false);

    const columns = useMemo(() => [
          { size: 40, accessorKey: 'Company',   header: 'Företag', enableColumnActions: false },
          { size: 40, accessorKey: 'eMail',  header: 'Epost' },
          { size: 40, accessorKey: 'VATIdentification',  header: 'Orgnr' },
          { size: 20, accessorKey: 'SwishIdentifier', header: 'SwishIdentifier', enableOrdering: false, enablePinning: false, enableColumnActions: true},                          
        ]
    );

    const initialState = { density: 'compact', columnVisibility: { 'Manuell registrering': false, 'Visa på prislista':false, 'Price':false } };

    if (!loading  && resultSuccess) {
        return (
            <ContentWrapper>
                {instanceDetailsData!=null &&
                    <>
                    <Modal show={instanceDetailsModalshow} onHide={() => setInstanceDetailsModalshow(false)}>
                        <Modal.Header closeButton>
                            <Modal.Title>{instanceDetailsData.Company} ({instanceDetailsData.VATIdentification})</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            <Form id="ProductForm">
                                <Form.Group className="mb-3" >
                                    <Form.Label>eMail</Form.Label>
                                    <Form.Control type="text" name="eMail" placeholder="eMail"  defaultValue={instanceDetailsData.eMail} disabled />
                                </Form.Group>

                                <Form.Group className="mb-3" >
                                    <Form.Label>Telefon</Form.Label>
                                    <Form.Control type="text" name="Phone" placeholder="Telefon"  defaultValue={instanceDetailsData.Phone} disabled />
                                </Form.Group>

                                <Form.Group className="mb-3" >
                                    <Form.Label>Swishnummer</Form.Label>
                                    <Form.Control type="text" name="SwishIdentifier" placeholder="Swishnummer"  defaultValue={instanceDetailsData.SwishIdentifier} disabled />
                                </Form.Group>                                    	                                                                 	                                  							

                                <Form.Group className="mb-3"  hidden={!loading}>
                                    <SpinnerX  />
                                </Form.Group>                                      

                                <Form.Group className="mb-3"  hidden={!resultVisible}>
                                    <Alert show={resultVisible} variant={resultVariant}  className="FormSpace">{resultText}</Alert> 
                                </Form.Group> 												 													
                            </Form>                                           
                        </Modal.Body>
                        <Modal.Footer>
                            <Button className="QmeButton"  style={{backgroundColor:Branding().ButtonColor}} variant="primary" type="button" onClick={impersonate}>Impersonate</Button>                                        
                        </Modal.Footer>
                    </Modal>  
                    </>                 
                }

                <Container>
                    <Sida>                    
                        <MaterialReactTable  columns={columns} data={data.Instances} initialState={initialState}
                            muiTablePaginationProps={{ showFirstButton: false, showLastButton: false ,labelRowsPerPage:"Rader", rowsPerPageOptions: [25, 50, 100]}}
                            renderTopToolbarCustomActions={() => (<Rubrik>Instanser</Rubrik>)}
                            muiTablePaperProps={{elevation: 0, sx: {borderRadius: '0',border: '0px dashed #e0e0e0'} }} 
                            muiTableBodyRowProps={({ row }) => ({
                                onClick: (event) => {showInstanceDetailsHandler(event, row);},sx: {cursor: 'pointer'},}
                            )}
                        />                         
                    </Sida>
                </Container>
            </ContentWrapper>
        );
    } else {
        return (<Loading />);        
    }
}